import './assets/styles/main.scss';
import 'primeicons/primeicons.css';

import { createApp } from 'vue';

import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Sentry from '@tagboard/lib-sentry-vue';
import App from './App.vue';
import router from './router';

import {
  SENTRY_DSN,
  NODE_ENV,
  COMMIT_HASH,
  SENTRY_TRACES_SAMPLE_RATE,
} from './config/appConfig';

const app = createApp(App);

app.use(PrimeVue, {
  // Default theme configuration
  theme: 'none',
});

app.use(router);
app.use(ToastService);

try {
  Sentry.init({
    dsn: SENTRY_DSN,
    env: NODE_ENV,
    release: COMMIT_HASH,
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    app,
    router,
  });

  window.Sentry = Sentry.client;
} catch (err) {
  console.error('Failed to initialize Sentry:', err);
}

app.mount('#app');
